
const Button = ({styles}) => {
  return (
    <button type="button" className={`py-3 px-6 mt-10 font-montserrat font-medium text-[18px] bg-blue-gradient rounded-[10px] outline-none`}>Button</button>
  )
}

export default Button